<template>
    <div style="margin:15px 40px 0">
        <a-table :columns="columns" :data-source="data" style="background-color: transparent !important;color:#fff"
            :pagination="false">
            <template #headerCell="{ column }">
                <template v-if="column.key === 'name'">
                    <span>
                        {{ column.name }}
                    </span>
                </template>
            </template>

            <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'name'">

                    {{ record.name }}

                </template>


            </template>
        </a-table>
        <!-- <div style="padding-top:15px;text-align:right;padding-right:20px">
            <a-pagination :total="50" :pageSize="5" responsive :current="2" :hideOnSinglePage="true"
                :position="[bottomRight]" />
        </div> -->
        <a-pagination :total="pagination.total" :pageSize="pagination.pageSize" responsive :current="pagination.current"
            :position="[bottomRight]" @change="pageChanged" />
    </div>
</template>

<script>
import http from "@/api/http";
import { useStore } from "vuex";
import { defineComponent, ref, reactive, onMounted } from 'vue';
//import * as echarts from 'echarts';

export default defineComponent({
    components: {

    },

    setup() {


        const columns = [{
            title: '时间',
            dataIndex: 'createdAtText',
            key: 'createdAtText',
        }, {
            title: '日充电数量',
            dataIndex: 'todayChargeTotal',
            key: 'todayChargeTotal',
        }, {
            title: '谷段充电量',
            dataIndex: 'todayValleyChargeTotal',
            key: 'todayValleyChargeTotal',
        },
        // {
        //     title: '平段充电量',
        //     key: 'tags',
        //     dataIndex: 'tags',
        // }, 
        {
            title: '日放电量',
            dataIndex: 'todayDischargeAhTotal',
            key: 'todayDischargeAhTotal',
        }, {
            title: '峰段放电量',
            dataIndex: 'todayPeakDischargeTotal',
            key: 'todayPeakDischargeTotal',
        }, {
            title: '平段放电量',
            dataIndex: 'todayFlatDischargeTotal',
            key: 'todayFlatDischargeTotal',
        },
            // {
            //     title: '尖峰放电量',
            //     dataIndex: 'jianfeng',
            //     key: 'jianfeng',
            // }, {
            //     title: '节省电费统计',
            //     dataIndex: 'jiesheng',
            //     key: 'jiesheng',
            // }
        ];
        let data = ref([]);
        const expand = ref(true);
        const formRef = ref();
        const formState = reactive({});

        const pagination = ref({
            current: 1,
            pageSize: 3,
            total: 0,
        });

        const onFinish = values => {
            console.log('Received values of form: ', values);
            console.log('formState: ', formState);
        };



        const store = useStore()
        let stationid = store.getters['User/stationid']
        const getData = (page, pageSize) => {
            http.get("/base_station/" + stationid + "/ems/statistics?pageSize=" + pageSize + "&pageNum=" + page).then((res) => {
                // console.log('121', res)
                pagination.value.total = res.data.total;
                pagination.value.pageSize = res.data.size;
                pagination.value.current = res.data.current;
                res.data.records.some(() => {

                    data.value = res.data.records;



                });

            });
        };

        const pageChanged = (page, pageSize) => {
            getData(page, pageSize);
        }


        onMounted(() => { //组件挂载时的生命周期执行的方法

            getData(pagination.value.current, pagination.value.pageSize)
        });

        return {

            formRef,
            formState,
            expand,
            onFinish,
            value1: ref('请选择'),
            data,
            columns, pagination, pageChanged

        }
    }
});
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ant-pagination {
    text-align: right;
    padding-top: 20px !important;
    padding-right: 20px;
}
</style>
